export const formatFundsMainPart = (funds: number): string => {
  if (!funds) {
    return '';
  }
  return funds.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDecimalExtension = (funds: number): string => {
  const decimalPart = funds.toString().split('.')[1] || '';
  return decimalPart.length > 2 ? decimalPart.substring(2) : '';
};

export const formatFundsInCurrencyString = (funds: number): string => {
  try {
    return Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(Number(funds));
  } catch (e) {
    return String(funds);
  }
};

export const capitalizeText = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const displayBoolean = (value: boolean): string => {
  return value ? 'True' : 'False';
};

export const formatZAR = (value: unknown): string => {
  const numberValue = Number(value);

  if (!Number.isFinite(numberValue)) return 'R0';

  return `R${numberValue.toLocaleString('en-ZA', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};
